import api from './api';

export const userService = {
  async getUsers() {
    const response = await api.get('/admin/users');
    return response.data;
  },

  async createUser(data) {
    const response = await api.post('/admin/users', data);
    return response.data.data;
  },

  async updateUser(id, data) {
    const response = await api.put(`/admin/users/${id}`, data);
    return response.data.data;
  },

  async updatePassword(id, data) {
    const response = await api.put(`/admin/users/${id}/password`, data);
    return response.data;
  },

  async deleteUser(id) {
    const response = await api.delete(`/admin/users/${id}`);
    return response.data;
  },
};
